// extracted by mini-css-extract-plugin
export default {"button":"So-z","reviewSort":"To-z"};